import { MenuHeader } from "@szhsin/react-menu";

import cn from "@utils/cn";
import NavbarMenuDividerItem from "@components/navbar/menu/menu_item_types/NavbarMenuDividerItem";

const CLASS_NAMES = cn(`
  px-4
  py-2
  leading-normal
  text-[#444444]
`);

export default function NavbarMenuTextItem(props) {
  const {
    label,
  } = props;

  const hasDivider = props.hasDivider ?? false;

  const text = label.text;

  /**************************************************************************************************/

  return (
    <>
      {hasDivider && (
        <NavbarMenuDividerItem />
      )}

      <MenuHeader className={CLASS_NAMES}>
        {text}
      </MenuHeader>
    </>
  );
}
